/* eslint-disable */
import * as types from './action_types';
import Immutable from 'immutable';

export const initialState = Immutable.fromJS({
  loading: false,
  error: undefined,
  log: []
});

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.POINTS_LOG_RETRIEVING:
      return state.merge({ loading: true });
    case types.POINTS_LOG_RETRIEVED:
      return state.merge({ loading: false, error: undefined, log: action.pointsLog });
    case types.POINTS_LOG_ERROR:
      return state.merge({ error: action.error, loading: false });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/stores/points_log/reducer.js